import QuantityBasicSelector from '@/components/QuantitySelector/QuantityBasicSelector.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown.js';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useProductOptionsStore } from '@/shared/pinia/modules/product-options';
import { useProductQuantitiesStore } from '@/shared/pinia/modules/product-quantities';
import { getBulkDiscounts, useBulkDiscounts } from '@/shared/utils/discounts';

export const initQuantitySelector = async (mountSelector) => {
  const script = document.getElementById(mountSelector);

  if (!script) return;

  const quantityStore = useProductQuantitiesStore();
  const optionsStore = useProductOptionsStore();
  const productStore = useProductStore();

  const price = Number(script.dataset.price);
  const compareAtPrice = Number(script.dataset.compareAtPrice ?? null);
  const hasDifferentPrices = script.dataset.hasDifferentPrices === 'true';

  if (price) {
    productStore.price.initial_unit = price;
    productStore.price.unit = price;
  }

  const isOnSale = compareAtPrice > price;
  if (isOnSale) {
    productStore.price.savings = compareAtPrice - price;
    productStore.price.before = compareAtPrice;
  }

  const isBulkProduct = useBulkDiscounts(isOnSale, !!script.dataset.discounts);

  quantityStore.quantity = 1;

  const bulkDiscounts =
    isBulkProduct && getBulkDiscounts(script.dataset.discounts, price);
  if (bulkDiscounts?.length) {
    quantityStore.setBulkDiscounts(bulkDiscounts);
    quantityStore.quantity = bulkDiscounts[bulkDiscounts.length - 1].quantity;
  }

  optionsStore.haveDifferentPrices = hasDifferentPrices;

  const quantityComponent = QuantityBasicSelector;

  await mountCoreVueApp(
    quantityComponent,
    `#${mountSelector}`,
    {},
    (app) => {
      app.directive('global-keydown', GlobalKeyDownDirective);
    },
    { noClients: true }
  );
};
